import React from "react";
import { ComponentType } from "react";
import { connect } from "react-redux";

import { Dsp, DspsState } from "../../models";
import { getDspsArray } from "../../selectors";

export interface InjectedDspsProps {
    dsps: Dsp[];
}

const mapStateToProps = (state: DspsState) => ({
    dsps: getDspsArray(state),
});

export const withDsps = <P extends InjectedDspsProps>(
    WrappedComponent: ComponentType<P>,
) => {
    const ComponenWithDsps = (props: P) => (
        <WrappedComponent {...props} />
    );
    return connect(mapStateToProps)(ComponenWithDsps);
};
